import { AddCircle } from "@mui/icons-material"
import { IconButton, IconButtonProps, Menu, MenuItem, Tooltip } from "@mui/material"
import React, { useState } from "react"
import { AddNodeMode, addNodeModeAtom } from "@features/builder/graph/graphAtoms"
import { useSetAtom } from "jotai"

type AddNodeButtonProps = Omit<IconButtonProps, "onClick">

const AddNodeButton = (props: AddNodeButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const setAddNodeMode = useSetAtom(addNodeModeAtom)

  const handlePlusClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleAddNodeClick = () => {
    setAddNodeMode(AddNodeMode.CursorNode)
    setAnchorEl(null)
  }

  const handleAddGroupClick = () => {
    setAddNodeMode(AddNodeMode.CursorGroup)
    setAnchorEl(null)
  }

  return (
    <>
      <Tooltip title="Add node or group">
        <IconButton {...props} onClick={handlePlusClick}>
          <AddCircle color="error" sx={{ fontSize: 35 }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              transform: "translateX(-40px) translateY(-40px)",
            },
          },
        }}
        MenuListProps={{
          sx: { width: "200px" },
        }}
      >
        <MenuItem onClick={handleAddNodeClick}>Add Node</MenuItem>
        <MenuItem onClick={handleAddGroupClick}>Add Group</MenuItem>
      </Menu>
    </>
  )
}

export default AddNodeButton
